/**
 * A global namespace for `pointercancel` event.
 */
const pointercancelEvent = 'pointercancel';
export default pointercancelEvent;
